import { render, staticRenderFns } from "./PopupSingleListing.vue?vue&type=template&id=a688a572&scoped=true&"
import script from "./PopupSingleListing.vue?vue&type=script&lang=ts&"
export * from "./PopupSingleListing.vue?vue&type=script&lang=ts&"
import style0 from "./PopupSingleListing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PopupSingleListing.vue?vue&type=style&index=1&id=a688a572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a688a572",
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg,QSkeleton,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QImg,QSkeleton,QBtn,QIcon})
